import { useContext } from 'react';
import { Box, IconButton } from '@mui/material';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import TraitsReconciliationContext from '../../context/TraitsReconciliationContext';
import UnmappedRecordStatus from '../../enums/UnmappedRecordStatus';

const ProcedureName = styled.span`
    font-family: ${(props) => props.theme.typography.fontFamily};
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    flex-grow: 1;
`;

const StyledIconButton = styled(IconButton)(({ theme }) => `
    border: 1px solid ${theme.palette.primary.main} !important;
    border-radius: 4px!important;
    width: 28px;
    height: 28px;
    &:disabled {
        border-color: ${theme.palette.grey[500]}!important;
    }
`);

const NavIcon = styled(FontAwesomeIcon)(({ theme }) => `
  color: ${theme.palette.grey[600]};
  font-size: 16px;
  cursor: pointer;
  &:hover {
    color: ${theme.palette.grey[700]};
  }
`);

function ProcedureSelector() {
  const {
    procedures, currentProcedureConfig, setCurrentProcedureId, currentProcedureId, unmappedRecordsWithStatus, currentStudy,
  } = useContext(TraitsReconciliationContext);
  if (!procedures || procedures.length === 0 || !currentProcedureConfig?.procedureId || !currentProcedureId) {
    return null;
  }
  const procedureIndex = procedures.indexOf(currentProcedureId);

  const handleNextProcedureClick = () => {
    setCurrentProcedureId((procedureId) => {
      const currentProcedureIndex = procedures.indexOf(procedureId || '');
      return procedures[currentProcedureIndex + 1];
    });
  };

  const handlePreviousProcedureClick = () => {
    setCurrentProcedureId((procedureId) => {
      const currentProcedureIndex = procedures.indexOf(procedureId || '');
      return procedures[currentProcedureIndex - 1];
    });
  };
  const allRecordsResolved = unmappedRecordsWithStatus?.filter((record) => record.eSourceStudyId === currentStudy?.studyId)
    .every((record) => record.status === UnmappedRecordStatus.RESOLVED_HIDDEN) ?? false;

  return (
    <Box flexDirection="row" display="flex" gap={1} padding="12px 0" data-testid="procedure-selector">
      <ProcedureName data-testid="procedure-name">
        {currentProcedureConfig?.name}
      </ProcedureName>
      {!allRecordsResolved
            && (
            <>
              <StyledIconButton
                aria-label="previous"
                onClick={handlePreviousProcedureClick}
                disabled={procedureIndex < 1}
                data-testid="previous-procedure-button"
              >
                <NavIcon icon={faChevronLeft} aria-label="previous procedure" />
              </StyledIconButton>
              <StyledIconButton
                aria-label="next"
                onClick={handleNextProcedureClick}
                disabled={procedureIndex >= procedures.length - 1}
                data-testid="next-procedure-button"
              >
                <NavIcon icon={faChevronRight} />
              </StyledIconButton>
            </>
            )}
    </Box>
  );
}

export default ProcedureSelector;
